import { APPSTORE_URL, PLAYSTORE_URL } from "../../constants/Constants";

/* ─────────────────────────────────────────────────────────────
   handleOpenApp

   The app is now live on both stores, so this redirects the
   user straight to the App Store (iOS) or Play Store
   (everything else) instead of showing the old "coming soon"
   toast.
───────────────────────────────────────────────────────────── */

const handleOpenApp = () => {
  try {
    if (typeof window === "undefined") return;

    const isIPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    window.open(isIPhone ? APPSTORE_URL : PLAYSTORE_URL, "_blank", "noopener,noreferrer");
  } catch (error) {
    console.error(error);
  }
};

export default handleOpenApp;
